"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var _react = _interopRequireDefault(require("react"));

var _reactItemsCarousel = _interopRequireWildcard(require("react-items-carousel"));

var _ = require("../..");

var _Chevron = _interopRequireDefault(require("./Chevron"));

var css = _interopRequireWildcard(require("./Carousel.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Carousel component is a lightweight customizable React carousel component
 * that rocks supports multiple items
 *
 * ---
 *
 * *Infinite Loop Limitations:*
 *
 * If infiniteLoop was set to true, the following props are ignored
 *  - activePosition: will always be left
 *  - alwaysShowChevrons: will always be true
 */
const Carousel = /*#__PURE__*/_react.default.memo(({
  children,
  leftChevron,
  rightChevron,
  buttonVariant = 'primary',
  ...other
}) => {
  const [activeItemIndex, setActiveItemIndex] = _react.default.useState(0);

  return (0, _pragma.createFelaElement)(_.View, {
    css: css.wrapper
  }, (0, _pragma.createFelaElement)(_reactItemsCarousel.default, _extends({
    "aria-label": "carousel",
    requestToChangeActive: setActiveItemIndex,
    activeItemIndex: activeItemIndex,
    leftChevron: leftChevron || (0, _pragma.createFelaElement)(_Chevron.default, {
      type: "left",
      variant: buttonVariant
    }),
    rightChevron: rightChevron || (0, _pragma.createFelaElement)(_Chevron.default, {
      type: "right",
      variant: buttonVariant
    }),
    chevronWidth: 32
  }, other), children));
});

var _default = Carousel;
exports.default = _default;
//# sourceMappingURL=Carousel.js.map